import React, { Fragment, useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { Grid } from "@mui/material";

import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import { removeItemWithSlice } from "util/utils";
import PeopleIcon from "@mui/icons-material/People";
import PersonIcon from "@mui/icons-material/Person";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';


const useStyles = makeStyles((theme) => ({
  root: {
    margin: "-1rem 0 2rem 0",
    padding: "0 3rem",
    [theme.breakpoints.down("xs")]: {
      padding: "0",
    },
    [theme.breakpoints.down("md")]: {
      padding: "0",
    },
    marginTop: "auto",
  },
  textField: {
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  errorMessage: {
    color: "red",
    fontSize: "0.9rem",
    marginTop: "0.2rem",
  },

  card: {
    margin: "1rem 1rem 0.4rem 1rem",
    [theme.breakpoints.down("xs")]: {
      padding: "0",
    },
  
  }
}));

export default function TableSelect({
  formProps = {},
  data = [],
  session = {},
  partySize = 1,
}) {
  const { register, errors = {}, setValue } = formProps;
  const classes = useStyles();
  const { selectedTables } = data && data[0] ? data[0] : {};
  const [currentTables, setCurrentTables] = useState([]);
  const selectedTablesFieldName = "selectedTables";

  const checkTableCapacity = (tables) => {
    if (tables === null || tables === undefined || tables.length === 0) {
      return "Please select a table";
    }
    const maxCapacity = tables.reduce((count, curItem) => {
      return count + Number(curItem.guestNumber);
    }, 0);
    const minCapacity = tables.reduce((count, curItem) => {
      return count + Number(curItem.minNumOfGuests);
    }, 0);
    console.log("maxCapacity", maxCapacity, "minCapacity", minCapacity, tables);
    if (Number(partySize) >= minCapacity && Number(partySize) <= maxCapacity) {
      return true;
    } else {
      return "Please check tables maximum and minimum capacity requirements.";
    }
  };

  const tablesRequired = () => {
    return function validateRequired(value) {
      // console.log("VALIDATING: ", displayName, value);
      return checkTableCapacity(value);
    };
  };

  useEffect(() => {
    if (selectedTables) {
      setCurrentTables(selectedTables);
    }
  }, [data]);

  useEffect(() => {
    if (register) {
      register(selectedTablesFieldName, { validate: tablesRequired() });
    }
  }, [register]);

  const handleTableChange = (event, tableId, index) => {
    const idx = currentTables.findIndex((table) => table.id === tableId);
    if (idx !== -1) {
      const newTables = removeItemWithSlice(currentTables, idx);
      setCurrentTables(newTables);
      setValue(selectedTablesFieldName, newTables);
    } else {
      let tables = [...currentTables];
      const table = session.tables[index];
      if (table) {
        tables.push(table);
      }
      setCurrentTables(tables);
      setValue(selectedTablesFieldName, tables);
    }
  };

  const isTableChecked = (tableId) => {
    return currentTables.findIndex((table) => table.id === tableId) > -1;
  };

  const tableTitle = (currentSession, table, index) => {

    if (currentSession.hideTableNo === true) {
      const seqence = index + 1;
      return `Option ${seqence}`;
    } else {
      return `Table#: ${table.tableNumber}`;
    }
  };

  return (
    <Fragment>
      <div className={classes.root}>

        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
          spacing={1}
        >
          <Grid item md={12} xs={12}>
            <FormControl component="fieldset">
              <FormLabel component="legend">Tables</FormLabel>
              {session.tables && session.tables.map((table, index) => {
                return (
                  <Card className={classes.card}>
                    <CardContent>
                      <FormGroup row key={table.id}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={isTableChecked(table.id)}
                              onChange={(e) =>
                                handleTableChange(e, table.id, index)
                              }
                              name={table.id}
                            />
                          }
                          label={
                            <div>
                              <Typography variant="title" display='block' style={{ margin: 10 }}>
                                {tableTitle(session, table, index)}
                              </Typography>
                              <Typography variant="body">
                                <Grid container direction='row' justify="center">
                                  <PeopleIcon color="primary" /> Max:
                                  {table.guestNumber} <PersonIcon color="primary" />
                                  Min: {table.minNumOfGuests}
                                </Grid>
                              </Typography>

                            </div>
                          }
                        />
                      </FormGroup>
                   
                    </CardContent>

                  </Card>

                );
              })}

              {errors.selectedTables && (
                <p className={classes.errorMessage}>
                  {errors.selectedTables.message}
                </p>
              )}
            </FormControl>
          </Grid>
        </Grid>


      </div>
    </Fragment>
  );
}
